import resourceFactory from 'common/admin/resourceFactory'

const actions = resourceFactory('users')

export default actions
